import * as React from "react";
import { cn } from "@/lib/utils";

/**
 * The single source of truth for page-top subtitle typography. Every page
 * subtitle — the descriptive line directly below a {@link PageTitle}
 * (Documents, Projects, Project Management, Documents Log, …) — renders
 * through this component so size, weight, line-height, and letter-spacing
 * stay identical across the app.
 *
 * The reference is the building Dashboard "address" line: `text-sm`, normal
 * weight, normal tracking, muted foreground. Non-`<p>` subtitles that need
 * the same typography but a different element/layout (e.g. an address row
 * with a leading icon) should compose {@link pageSubtitleClassName} via `cn`
 * rather than re-declaring the classes, so they are guaranteed to match.
 */
export const pageSubtitleClassName = "text-sm font-normal tracking-normal text-muted-foreground";

export type PageSubtitleProps = React.HTMLAttributes<HTMLParagraphElement>;

export const PageSubtitle = React.forwardRef<HTMLParagraphElement, PageSubtitleProps>(
  function PageSubtitle({ className, children, ...props }, ref) {
    return (
      <p ref={ref} className={cn(pageSubtitleClassName, className)} {...props}>
        {children}
      </p>
    );
  }
);
